export function headerSticky() {
    let $header = $(".header");

    function stickyHeader() {
        let top = $(document).scrollTop();
        if (top > 0) {
            $header.addClass("sticky");
        } else {
            $header.removeClass("sticky");
        }
    }

    window.addEventListener("load", () => {
        stickyHeader();
    });
    window.addEventListener("scroll", () => {
        stickyHeader();
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/headerSticky.js